import { RootState } from "../..";
import Partner from "../../types/Partner";

export function getPartners(state: RootState): Partner[] {
  return state.map.partners;
}

export function getSingleMarkerResult(state: RootState): Partner {
  return state.map.singleMarkerResult;
}

export function getQueryResults(state: RootState): Partner[] {
  return state.map.queryResults;
}

export function getBounds(state: RootState): google.maps.LatLngBounds {
  return state.map.bounds;
}

export function getQuery(state: RootState): string {
  return state.map.query;
}

export function getError(state: RootState): any {
  return state.map.error;
}

export function getLoadingStatus(state: RootState): boolean {
  return state.map.isLoading;
}
